// © 2026 AttainIP Engineering

/**
 * Error-banner store — holds the single most-recent unhandled query/mutation
 * error surfaced by the QueryClient onError sink (RFC-0202 §"Session-Loss UX"
 * §2). Replace semantics: a new error overwrites the visible one rather than
 * queuing. For a flaky backend the user cares about the current state, not a
 * backlog of stale failures.
 */

import { create } from 'zustand';
import { ApiRequestError } from '../api/client';
import { getErrorMapping } from '../api/errors';

function toMessage(error: unknown): string {
  if (error instanceof ApiRequestError) {
    return getErrorMapping(error.code).message;
  }
  return getErrorMapping('UNKNOWN_ERROR').message;
}

export interface ErrorBannerState {
  message: string | null;
  setError: (error: unknown) => void;
  clear: () => void;
}

export const useErrorBannerStore = create<ErrorBannerState>((set) => ({
  message: null,
  setError: (error) => set({ message: toMessage(error) }),
  clear: () => set({ message: null }),
}));
